<template>
    <div>
        <!-- State Select -->
        <b-input-group prepend="State">
            <b-form-select v-model="currentState" :options="stateOptions" size="lg" @input="getPages()"></b-form-select>
        </b-input-group>

        <!-- Pages List -->
        <section class="mt-3">
            <b-card>
                <template #header>
                    <div class="row">
                        <div class="col-10">
                            <h4 class="m-0, pt-1">Pages</h4>
                        </div>
                        <div class="col-2">
                            <b-button class="float-right" variant="primary" @click="$bvModal.show('addPageModal')">
                                <font-awesome-icon :icon="['fas', 'plus']"/>
                            </b-button>
                        </div>
                    </div>
                </template>

                <template #default>
                    <b-table class="my-2" :items="pages" :fields="pageTableFields" striped>
                        <template #cell(title)="data">
                            <router-link :to="{name: 'page-editor', params: {id: data.item.id}}" >{{data.item.title}}</router-link>
                        </template>
                        <template #cell(actions)="data">
                            <b-button variant="danger" @click="confirmDeletePage(data.item)">
                                <font-awesome-icon :icon="['fas', 'trash']"/>
                            </b-button>
                        </template>
                    </b-table>
                </template>
            </b-card>
        </section>

        <!-- Add Page Modal -->
        <b-modal id="addPageModal" @ok="createNewPage()">
            <template #modal-header>
                <h3>Add Page</h3>
            </template>

            <b-input-group prepend="Identifier">
                <b-input type="text" v-model.trim="newPageId"></b-input>
            </b-input-group>
            <b-input-group prepend="State" class="mt-3">
                <b-form-select v-model="newPageState" :options="stateOptions"></b-form-select>
            </b-input-group>

            <template #modal-ok>
                Create Page
            </template>
        </b-modal>
        <!-- Delete Page Confirmation Modal -->
        <b-modal id="deletePageModal" @ok="deletePage()">
            <template #modal-header>
                Delete this page?
            </template>

            Are you sure you want to delete the '{{selectedPage.title}}' page?

            <template #modal-ok>
                Delete
            </template>
        </b-modal>
    </div>
</template>

<script>
import states from '@/common/states';
import {mapState} from "vuex";
export default {
    name: "PageAdmin",
    data: () => ({
        states: states,
        currentState: null,
        newPageId: '',
        newPageState: null,
        selectedPage: {},
        pageTableFields: [
            {key:'id', sortable: true},
            {key:'title', sortable: true},
            // {key:'state', sortable: true},
            'actions'
        ]
    }),
    computed: {
        stateOptions() {
            let options = states.map(({fullState, state}) => {
                return {value: state, text: fullState};
            });
            options.unshift({value: null, text: 'Default/All'});

            return options;
        },
        ...mapState({
            pages: (state) => state.stateData.pages,
        })
    },
    methods: {
        createNewPage() {
            let name = this.newPageId.replaceAll(' ', '-').toLowerCase();
            this.$store.dispatch('savePage', {key: name, title: this.newPageId,  state: this.newPageState})
            .then(() => {
                this.$swal('created');
                this.currentState = this.newPageState;
                this.getPages();
            })
        },
        getPages() {
            this.$nextTick(() => this.$store.dispatch('getPages', this.currentState));
        },
        confirmDeletePage(page) {
            this.selectedPage = page;
            this.$bvModal.show('deletePageModal');
        },
        deletePage() {
            this.axios.post(`pages/delete/${this.selectedPage.id}`)
            .then(() => {
                this.getPages();
            })
        }
    }
}
</script>

<style scoped>
hr {
    width: 97%;

    border-top: 1px solid gray;
}
</style>
<style>
#dashboard_nav {
    display: block;
}
</style>